import { Div } from "../../../../../base/components/native/div"
import { Img } from "../../../../../base/components/native/img"
import { Input } from "../../../../../base/components/native/input"
import { HIDE, SHOW } from "../../../../../base/helpers/style"
import { IMAGES } from "../../../../../configs/images"
import { baseStyle, inputStyle, linkStyle, titleStyle } from "./url-input.style"

export const TitleInput = (value: string) => {

    const base = Div()
    base.cssClass(baseStyle)

    const title = Div('عنوان صفحه')
    title.cssClass(titleStyle)
    base.append(title)

    const n = Div('')
    base.append(n)

    const input = Input('', 'text')
    input.cssClass(inputStyle)
    input.style({ textAlign: 'right', direction: 'rtl' })
    input.setValue(value)
    base.append(input)


    return Object.assign(base, {
        getValue: () => input.getValue(),
        setValue: (value: string) => {
            input.setValue(value) // todo fix oninput listener
        }
    })

}